import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthService } from './services/auth.service';
import { MenuPage } from './template/menu/menu.page';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'app/dashboard',
    pathMatch: 'full'
  },
  // {
  //   path: 'menu',
  //   loadChildren:'./template/menu/menu.module#MenuPageModule',canActivate:[AuthService]
  // },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'app',
    component: MenuPage,

    children:[
      // {
      //   path: 'home',
      //   loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
      // },
      {
        path:'users',
        loadChildren: () => import('./users/users.module').then( m => m.UsersPageModule)
      },
      {
        path:'roles',
        loadChildren: () => import('./users/roles/roles.module').then( m => m.RolesPageModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then( m => m.DashboardPageModule)
      },
      {
        path: 'masters',
        loadChildren: () => import('./masters/masters.module').then( m => m.MastersPageModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then( m => m.ReportsPageModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.module').then( m => m.SettingsPageModule)
      },
      {
        path: 'employees',
        loadChildren: () => import('./employees/employees.module').then( m => m.EmployeesPageModule)
      },
      {
        path: 'payments',
        loadChildren: () => import('./payments/payments.module').then( m => m.PaymentsPageModule)
      },
      {
        path: 'day-open-close',
        loadChildren: () => import('./day-open-close/day-open-close.module').then( m => m.DayOpenClosePageModule)
      },
      {
        path: 'attendance',
        loadChildren: () => import('./attendance/attendance.module').then( m => m.AttendancePageModule)
      },
      {
        path: 'production',
        loadChildren: () => import('./production/production.module').then( m => m.ProductionPageModule)
      },
      {
        path: 'purchases',
        loadChildren: () => import('./purchases/purchases.module').then( m => m.PurchasesPageModule)
      },
      {
        path: 'salary',
        loadChildren: () => import('./salary/salary.module').then( m => m.SalaryPageModule)
      },
      {
        path: 'hire-entry',
        loadChildren: () => import('./hire-entry/hire-entry.module').then( m => m.HireEntryPageModule)
      },
      {
        path: 'menu',
        loadChildren: () => import('./menu/menu.module').then( m => m.MenuPageModule)
      },
      {
        path: 'sales',
        loadChildren: () => import('./sales/sales.module').then( m => m.SalesPageModule)
      },
      {
        path: 'contract-labours',
        loadChildren: () => import('./contract-labours/contract-labours.module').then( m => m.ContractLaboursPageModule)
      }
    ],canActivate:[AuthService]
  },
  {
    path: 'masters',
    loadChildren: () => import('./masters/masters.module').then( m => m.MastersPageModule)
  },
  {
    path: 'employees',
    loadChildren: () => import('./employees/employees.module').then( m => m.EmployeesPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./authentication/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'day-open-close',
    loadChildren: () => import('./day-open-close/day-open-close.module').then( m => m.DayOpenClosePageModule)
  },
  {
    path: 'attendance',
    loadChildren: () => import('./attendance/attendance.module').then( m => m.AttendancePageModule)
  },
  {
    path: 'production',
    loadChildren: () => import('./production/production.module').then( m => m.ProductionPageModule)
  },
  {
    path: 'camera-picture',
    loadChildren: () => import('./utils/camera-picture/camera-picture.module').then( m => m.CameraPicturePageModule)
  },
  {
    path: 'salary',
    loadChildren: () => import('./salary/salary.module').then( m => m.SalaryPageModule)
  },
  {
    path: 'hire-entry',
    loadChildren: () => import('./hire-entry/hire-entry.module').then( m => m.HireEntryPageModule)
  },
   {
    path: 'menu',
    loadChildren: () => import('./menu/menu.module').then( m => m.MenuPageModule)
  },
  {
    path: 'sales',
    loadChildren: () => import('./sales/sales.module').then( m => m.SalesPageModule)
  },
  {
    path: 'contract-labours',
    loadChildren: () => import('./contract-labours/contract-labours.module').then( m => m.ContractLaboursPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
